<template>
  <CRow class="main py-5 mt-3">
    <CCol sm="8" class="py-5">
      <CRow>
        <CCol sm="12" class="d-flex flex-column">
          <div>
            <h2 class="titlePage font-weight-normal text-capitalize pb-4">
              {{ $t('sender.domainSender.newDomain.title') }}
            </h2>
          </div>
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol>
          <div class="d-flex justify-content-between border-b">
            <h3 class="font-weight-normal text-capitalize">
              {{ $t('sender.domainSender.newDomain.text2') }}
            </h3>
            <CButton :to="{ name: 'senders-domain' }" class="bg-gray-200 px-4 py-2">{{ $t('sender.domainSender.newDomain.button-cancel') }}</CButton>
          </div>
          <div class="my-4">
            <p class="p-0">
              {{ $t('sender.domainSender.newDomain.text3') }}
            </p>
            <p class="p-0">
              {{ $t('sender.domainSender.newDomain.text4') }}
            </p>
          </div>

          <div class="my-2">
            <h4 class="font-weight-normal text-capitalize mb-3">
              {{ $t('sender.domainSender.newDomain.text-domain') }}
            </h4>
            <CForm @submit.prevent="sendSender">
              <CInput
                style="max-width: 300px"
                :value.sync="$v.senderDomain.$model"
                :isValid="checkIfValid('senderDomain')"
                :invalidFeedback="$t('sender.domain.inputFeedback')"
                type="text"
                :placeholder="$t('sender.domainSender.newDomain.placehoder-domain')"
                v-model="senderDomain"
              />
              <div class="fd-flex finishArea">
                <CButton
                  type="submit"
                  color="primary"
                  :disabled="disableAdd || $v.senderDomain.$error || $v.senderDomain.$model == ''"
                  class="mt-4 text-uppercase px-3 mb-5"
                  >{{ $t('sender.domainSender.newDomain.button-addDomain') }}</CButton
                >
              </div>
            </CForm>
          </div>

          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'

import { validationMixin } from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'

const domain = helpers.regex('domain', /^(?:[a-zA-ZA0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]*$/)

export default {
  name: 'SendersDomain',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      loading: false,
      disableAdd: false,
      messages: [],
      senderDomain: '',
      buttonClicked: false,
      messageDomainAdded: this.$t('sender.domainSender.newDomain.button-messageDomainAdded'),
    }
  },
  validations: {
    senderDomain: {
      domain,
    },
  },
  mixins: [validationMixin],
  computed: {
    isDisabled() {
      return !this.senderDomain.$invalid
    },
  },
  methods: {
    sendSender() {
      this.messages = []
      this.loading = true
      this.buttonClicked = true
      let body = {
        domainSender: this.senderDomain,
      }
      this.disableAdd = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .createSenderDomain(organizationId, body)
        .then(() => {
          this.messages.push({
            status: 'warning',
            text: this.messageDomainAdded,
          })

          setTimeout(() => {
            this.$router.push({ name: 'senders-domain' })
          }, 5000)

          this.clean()
        })
        .catch(({ response }) => {
          const errorMessage = response.data.Message || response.data.message
          this.messages.push({
            status: 'danger',
            text: this.$t(`general.errors.${errorMessage}`)
          })
        })
        .finally(() => {
          this.loading = false
          this.buttonClicked = false
          this.disableAdd = false
        })
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    clean() {
      this.senderDomain = ''
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  color: var(--gray-600);
}

.border-b {
  padding-bottom: 0.6rem;
  border-bottom: 1px solid var(--gray-500);
}
</style>

<style lang="scss">
.finishArea {
  .custom-control-label {
    padding-top: 5px;
    padding-left: 5px;
    color: var(--gray-600);
  }
}
</style>
